var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=container.lambda, alias2=container.escapeExpression, buffer = 
  "     <p>\r\n         <a href=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.Constantes : depth0)) != null ? stack1.Dominios : stack1)) != null ? stack1.micuenta : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.Model : depth0)) != null ? stack1.Usuario : stack1)) != null ? stack1.Email : stack1), depth0))
    + "</a>\r\n";
  stack1 = ((helper = (helper = helpers.NotProductPremium || (depth0 != null ? depth0.NotProductPremium : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"NotProductPremium","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!helpers.NotProductPremium) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "         <a href=\"#\" class=\"next-button nav-login__cambiar\" data-step=\"logout\">Cambiar cuenta</a>\r\n     </p>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "         \r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "    <p>&iquest;Ya sos suscriptor digital? <a href=\"#\" class=\"next-button\" data-step=\"ya_tenes_suscripcion\">Ingres&aacute;</a></p>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"nav-login\">\r\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? depth0.Model : depth0)) != null ? stack1.Usuario : stack1)) != null ? stack1.UsuarioUsuario : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/nav.hbs
// module id = 527
// module chunks = 0